/**
 * Legacy registration records for WSG Energy Group Meeting 2025 - Europe
 */

import { LegacyRegistrationRecord, LegacyRegistrationUpdateRecord } from './WSGIBAAnnualNetworkingLuncheon2025';

export const WSGEnergyGroupMeeting2025EuropeRecords: LegacyRegistrationRecord[] = [
  { recid: 29895, regcontactid: 20831, regcompid: 9215, regevent: "WSG Energy Group Meeting 2025 - Europe", regname: "Marc Baltus", regemail: "m.baltus@heuking.de", regorganization: "Heuking", regpaytype: "cc", regpaid: 1, regcomments: null, regcreated: "2025-07-23 16:47:34.177", rbadge: null, rguest1: null, rdietary: null },
  { recid: 30116, regcontactid: 20881, regcompid: 5298, regevent: "WSG Energy Group Meeting 2025 - Europe", regname: "Lukasz Szegda", regemail: "lukasz.szegda@wardynski.com.pl", regorganization: "Wardynski & Partners", regpaytype: "cc", regpaid: 1, regcomments: null, regcreated: "2025-08-27 05:55:00.497", rbadge: null, rguest1: null, rdietary: null },
  { recid: 30055, regcontactid: 25814, regcompid: 330, regevent: "WSG Energy Group Meeting 2025 - Europe", regname: "Milos Vuckovic", regemail: "milos.vuckovic@karanovicpartners.com", regorganization: "Karanovic & Partners", regpaytype: "cc", regpaid: 1, regcomments: null, regcreated: "2025-08-14 07:17:26.763", rbadge: null, rguest1: null, rdietary: null },
  { recid: 30090, regcontactid: 31119, regcompid: 10092, regevent: "WSG Energy Group Meeting 2025 - Europe", regname: "Giuseppe Velluto", regemail: "gvelluto@gop.it", regorganization: "Gianni & Origoni", regpaytype: "cc", regpaid: 1, regcomments: null, regcreated: "2025-08-22 06:47:09.860", rbadge: null, rguest1: null, rdietary: null },
  { recid: 29930, regcontactid: 37702, regcompid: 8788, regevent: "WSG Energy Group Meeting 2025 - Europe", regname: "Brendan Clark", regemail: "brendan.clark@minterellison.com", regorganization: "MinterEllison", regpaytype: "cc", regpaid: 1, regcomments: null, regcreated: "2025-07-28 21:36:04.283", rbadge: null, rguest1: null, rdietary: null },
  { recid: 30049, regcontactid: 47146, regcompid: 330, regevent: "WSG Energy Group Meeting 2025 - Europe", regname: "Petar Mitrovic", regemail: "petar.mitrovic@karanovicpartners.com", regorganization: "Karanovic & Partners", regpaytype: "cc", regpaid: 1, regcomments: null, regcreated: "2025-08-13 04:40:54.733", rbadge: null, rguest1: null, rdietary: null },
  { recid: 29939, regcontactid: 52460, regcompid: 10128, regevent: "WSG Energy Group Meeting 2025 - Europe", regname: "Ramona Wyss", regemail: "ramona.wyss@walderwyss.com", regorganization: "Walder Wyss Ltd.", regpaytype: "cc", regpaid: 1, regcomments: null, regcreated: "2025-07-29 07:21:51.247", rbadge: null, rguest1: null, rdietary: null },
  { recid: 29971, regcontactid: 55141, regcompid: 10066, regevent: "WSG Energy Group Meeting 2025 - Europe", regname: "Marie Brasseur", regemail: "marie.brasseur@altius.com", regorganization: "ALTIUS/Tiberghien", regpaytype: "cc", regpaid: 1, regcomments: "Please transfer amount paid to William Timmermans registration.", regcreated: "2025-07-31 09:41:34.703", rbadge: null, rguest1: null, rdietary: null },
  { recid: 30225, regcontactid: 55161, regcompid: 10066, regevent: "WSG Energy Group Meeting 2025 - Europe", regname: "William Timmermans", regemail: "william.timmermans@altius.com", regorganization: "ALTIUS/Tiberghien", regpaytype: "cc", regpaid: 1, regcomments: "Amount should be paid through a registration transfer from Marie Brasseur (she already paid, cancelled, and requested the transfer)", regcreated: "2025-09-11 15:54:51.130", rbadge: null, rguest1: null, rdietary: null },
  { recid: 30001, regcontactid: 56708, regcompid: 9215, regevent: "WSG Energy Group Meeting 2025 - Europe", regname: "Tobias Woltering", regemail: "t.woltering@heuking.de", regorganization: "Heuking", regpaytype: "cc", regpaid: 1, regcomments: null, regcreated: "2025-08-06 06:27:07.173", rbadge: null, rguest1: null, rdietary: null },
  { recid: 29958, regcontactid: 65027, regcompid: 307, regevent: "WSG Energy Group Meeting 2025 - Europe", regname: "Tomas Travnicek", regemail: "ttravnicek@ksb.cz", regorganization: "Kocian Solc Balastik", regpaytype: "cc", regpaid: 1, regcomments: null, regcreated: "2025-07-30 08:32:41.583", rbadge: null, rguest1: null, rdietary: null },
  { recid: 30170, regcontactid: 68583, regcompid: 10277, regevent: "WSG Energy Group Meeting 2025 - Europe", regname: "Adrien Fourmon", regemail: "afourmon@jeantet.fr", regorganization: "Jeantet", regpaytype: "cc", regpaid: 0, regcomments: null, regcreated: "2025-09-05 15:23:48.453", rbadge: null, rguest1: null, rdietary: null },
  { recid: 30040, regcontactid: 69435, regcompid: 9365, regevent: "WSG Energy Group Meeting 2025 - Europe", regname: "Léone Klapwijk", regemail: "klapwijkl@vandoorne.com", regorganization: "Van Doorne", regpaytype: "cc", regpaid: 0, regcomments: null, regcreated: "2025-08-11 15:35:26.280", rbadge: null, rguest1: null, rdietary: null },
  { recid: 30034, regcontactid: 72093, regcompid: 8183, regevent: "WSG Energy Group Meeting 2025 - Europe", regname: "Helene Andersson", regemail: "helene.andersson@delphi.se", regorganization: "Delphi", regpaytype: "cc", regpaid: 1, regcomments: null, regcreated: "2025-08-09 06:16:55.363", rbadge: null, rguest1: null, rdietary: null },
  { recid: 30107, regcontactid: 74994, regcompid: 5298, regevent: "WSG Energy Group Meeting 2025 - Europe", regname: "Igor Hanas", regemail: "igor.hanas@wardynski.com.pl", regorganization: "Wardynski & Partners", regpaytype: "cc", regpaid: 1, regcomments: null, regcreated: "2025-08-26 06:34:30.000", rbadge: null, rguest1: null, rdietary: null },
  { recid: 30172, regcontactid: 75950, regcompid: 10277, regevent: "WSG Energy Group Meeting 2025 - Europe", regname: "Hélène Gelas", regemail: "hgelas@jeantet.fr", regorganization: "Jeantet", regpaytype: "cc", regpaid: 0, regcomments: null, regcreated: "2025-09-05 15:24:29.197", rbadge: null, rguest1: null, rdietary: null },
  { recid: 30173, regcontactid: 75951, regcompid: 10277, regevent: "WSG Energy Group Meeting 2025 - Europe", regname: "Philippe Raybaud", regemail: "praybaud@jeantet.fr", regorganization: "Jeantet", regpaytype: "cc", regpaid: 0, regcomments: null, regcreated: "2025-09-05 15:25:00.693", rbadge: null, rguest1: null, rdietary: null },
  { recid: 30171, regcontactid: 75956, regcompid: 10277, regevent: "WSG Energy Group Meeting 2025 - Europe", regname: "Alexae Fournier-de Faÿ ", regemail: "afournierdefay@jeantet.fr", regorganization: "Jeantet", regpaytype: "cc", regpaid: 0, regcomments: null, regcreated: "2025-09-05 15:24:11.473", rbadge: null, rguest1: null, rdietary: null },
  { recid: 30118, regcontactid: 83129, regcompid: 3021, regevent: "WSG Energy Group Meeting 2025 - Europe", regname: "Leonardo Vertiz", regemail: "lvertiz@worldservicesgroup.com", regorganization: "World Services Group", regpaytype: "cc", regpaid: 0, regcomments: null, regcreated: "2025-08-27 17:30:38.463", rbadge: null, rguest1: null, rdietary: null },
  { recid: 30206, regcontactid: 84135, regcompid: 2011, regevent: "WSG Energy Group Meeting 2025 - Europe", regname: "Álvaro Valle de Alvear", regemail: "alvaro.valle@garrigues.com", regorganization: "Garrigues", regpaytype: "wire", regpaid: 0, regcomments: null, regcreated: "2025-09-09 07:48:32.760", rbadge: null, rguest1: null, rdietary: null },
  { recid: 29955, regcontactid: 84138, regcompid: 9219, regevent: "WSG Energy Group Meeting 2025 - Europe", regname: "Tatjana Katalan", regemail: "tatjana.katalan@dorda.at", regorganization: "DORDA", regpaytype: "wire", regpaid: 1, regcomments: "Please transfer this amount to a future registration fee.", regcreated: "2025-07-30 03:11:04.417", rbadge: null, rguest1: null, rdietary: null },
  { recid: 29984, regcontactid: 84566, regcompid: 10092, regevent: "WSG Energy Group Meeting 2025 - Europe", regname: "Ottaviano Sanseverino Vimercati", regemail: "osanseverino@gop.it", regorganization: "Gianni & Origoni", regpaytype: "wire", regpaid: 1, regcomments: null, regcreated: "2025-08-01 18:15:33.940", rbadge: null, rguest1: null, rdietary: null },
  { recid: 30117, regcontactid: 87185, regcompid: 2843, regevent: "WSG Energy Group Meeting 2025 - Europe", regname: "David McElroy", regemail: "dmcelroy@algoodbody.com", regorganization: "A&L Goodbody LLP", regpaytype: "wire", regpaid: 0, regcomments: null, regcreated: "2025-08-27 12:13:36.893", rbadge: null, rguest1: null, rdietary: null },
  { recid: 30208, regcontactid: 87903, regcompid: 2011, regevent: "WSG Energy Group Meeting 2025 - Europe", regname: "Luis Enrique Mata Palacios", regemail: "luis.enrique.mata@garrigues.com", regorganization: "Garrigues", regpaytype: "cc", regpaid: 0, regcomments: null, regcreated: "2025-09-09 14:22:57.640", rbadge: null, rguest1: null, rdietary: null },
];

/**
 * Records for updating existing registrations with explicit amount paid and payment status
 * These records are specifically for editing/updating payment information
 */
export const WSGEnergyGroupMeeting2025EuropeUpdateRecords: LegacyRegistrationUpdateRecord[] = [
  // Unpaid records (amountPaid: 0)
  { 
    recid: 30206, 
    regcontactid: 84135, 
    regcompid: 2011, 
    regevent: "WSG Energy Group Meeting 2025 - Europe", 
    regname: "Álvaro Valle de Alvear", 
    regemail: "alvaro.valle@garrigues.com", 
    regorganization: "Garrigues", 
    regpaytype: "wire", 
    regpaid: 0, 
    regcomments: null, 
    regcreated: "2025-09-09 07:48:32.760", 
    rbadge: null, 
    rguest1: null, 
    rdietary: null,
    amountPaid: 0,
    paymentStatus: 'pending'
  },
  { 
    recid: 30171, 
    regcontactid: 75956, 
    regcompid: 10277, 
    regevent: "WSG Energy Group Meeting 2025 - Europe", 
    regname: "Alexae Fournier-de Faÿ ", 
    regemail: "afournierdefay@jeantet.fr", 
    regorganization: "Jeantet", 
    regpaytype: "cc", 
    regpaid: 0, 
    regcomments: null, 
    regcreated: "2025-09-05 15:24:11.473", 
    rbadge: null, 
    rguest1: null, 
    rdietary: null,
    amountPaid: 0,
    paymentStatus: 'pending'
  },
  { 
    recid: 30172, 
    regcontactid: 75950, 
    regcompid: 10277, 
    regevent: "WSG Energy Group Meeting 2025 - Europe", 
    regname: "Hélène Gelas", 
    regemail: "hgelas@jeantet.fr", 
    regorganization: "Jeantet", 
    regpaytype: "cc", 
    regpaid: 0, 
    regcomments: null, 
    regcreated: "2025-09-05 15:24:29.197", 
    rbadge: null, 
    rguest1: null, 
    rdietary: null,
    amountPaid: 0,
    paymentStatus: 'pending'
  },
  { 
    recid: 30173, 
    regcontactid: 75951, 
    regcompid: 10277, 
    regevent: "WSG Energy Group Meeting 2025 - Europe", 
    regname: "Philippe Raybaud", 
    regemail: "praybaud@jeantet.fr", 
    regorganization: "Jeantet", 
    regpaytype: "cc", 
    regpaid: 0, 
    regcomments: null, 
    regcreated: "2025-09-05 15:25:00.693", 
    rbadge: null, 
    rguest1: null, 
    rdietary: null,
    amountPaid: 0,
    paymentStatus: 'pending'
  },
  // Partial payment records
  { 
    recid: 30208, 
    regcontactid: 87903, 
    regcompid: 2011, 
    regevent: "WSG Energy Group Meeting 2025 - Europe", 
    regname: "Luis Enrique Mata Palacios", 
    regemail: "luis.enrique.mata@garrigues.com", 
    regorganization: "Garrigues", 
    regpaytype: "cc", 
    regpaid: 0, 
    regcomments: null, 
    regcreated: "2025-09-09 14:22:57.640", 
    rbadge: null, 
    rguest1: null, 
    rdietary: null,
    amountPaid: 290,
    paymentStatus: 'partial'
  },
  { 
    recid: 30117, 
    regcontactid: 87185, 
    regcompid: 2843, 
    regevent: "WSG Energy Group Meeting 2025 - Europe", 
    regname: "David McElroy", 
    regemail: "dmcelroy@algoodbody.com", 
    regorganization: "A&L Goodbody LLP", 
    regpaytype: "wire", 
    regpaid: 0, 
    regcomments: null, 
    regcreated: "2025-08-27 12:13:36.893", 
    rbadge: null, 
    rguest1: null, 
    rdietary: null,
    amountPaid: 275,
    paymentStatus: 'partial'
  },
  { 
    recid: 30040, 
    regcontactid: 69435, 
    regcompid: 9365, 
    regevent: "WSG Energy Group Meeting 2025 - Europe", 
    regname: "Léone Klapwijk", 
    regemail: "klapwijkl@vandoorne.com", 
    regorganization: "Van Doorne", 
    regpaytype: "cc", 
    regpaid: 0, 
    regcomments: null, 
    regcreated: "2025-08-11 15:35:26.280", 
    rbadge: null, 
    rguest1: null, 
    rdietary: null,
    amountPaid: 285,
    paymentStatus: 'partial'
  },
];

